import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
// import api from '../../api'; // Keep for future backend integration

const UserProfile = () => {
  const [loading, setLoading] = useState(true);
  
  // Initialize state matching your JSON structure
  const [formData, setFormData] = useState({
    parName: '', // Maps to "parName"
    email: '',
    mobile1: '', // Maps to "mobile1"
    address1: '', // Maps to "address1"
    city: '',     
    pincode: ''
  });

  useEffect(() => {
    // 1. Fetch User Data from Local Storage
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setFormData({
            parName: user.parName || '',
            email: user.email || '',
            mobile1: user.mobile1 || '',
            address1: user.address1 || '', 
            city: user.city || '',
            pincode: user.pincode || ''
        });
      } catch (e) {
        console.error("Error parsing user data", e);
      }
    }
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 1. Update Local Storage (So Header updates immediately)
    const userStr = localStorage.getItem("user");
    if(userStr) {
        const currentUser = JSON.parse(userStr);
        const updatedUser = { ...currentUser, ...formData };
        localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    // 2. Simulate Backend Update (Replace with real API call later)
    // await api.put('/user/update', formData); 
    
    toast.success("Profile Updated Successfully!");
    
    // Optional: Reload to reflect changes in Header immediately
    setTimeout(() => window.location.reload(), 1000);
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;

  return (
    <div className="container py-5" style={{ minHeight: '80vh' }}>
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm border-0 rounded-4">
            
            {/* Header with Navigation to Orders */}
            <div className="card-header bg-warning text-white p-4 rounded-top-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0 fw-bold"><i className="fa fa-user-circle me-2"></i> My Profile</h4>
                <Link to="/orders" className="btn btn-light btn-sm fw-bold rounded-pill text-dark shadow-sm">
                    <i className="fa fa-box-open me-1"></i> My Orders
                </Link>
            </div>
            
            <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                    
                    {/* Name Field */}
                    <div className="mb-3">
                        <label className="form-label fw-bold small text-muted">FULL NAME</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            name="parName" 
                            value={formData.parName} 
                            onChange={handleChange} 
                            placeholder="Enter your full name"
                        />
                    </div>

                    {/* Email Field (Read Only) */}
                    <div className="mb-3">
                        <label className="form-label fw-bold small text-muted">EMAIL ADDRESS</label>
                        <input 
                            type="email" 
                            className="form-control bg-light" 
                            name="email" 
                            value={formData.email} 
                            readOnly 
                        />
                    </div>

                    {/* Phone Field */}
                    <div className="mb-3">
                        <label className="form-label fw-bold small text-muted">PHONE NUMBER</label>
                        <div className="input-group">
                            <span className="input-group-text bg-light">+91</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="mobile1" 
                                value={formData.mobile1} 
                                onChange={handleChange} 
                            />
                        </div>
                    </div>

                    {/* Address Field */}
                    <div className="mb-4">
                        <label className="form-label fw-bold small text-muted">DELIVERY ADDRESS</label>
                        <textarea 
                            className="form-control" 
                            rows="3" 
                            name="address1" 
                            value={formData.address1} 
                            onChange={handleChange}
                            placeholder="Enter your full address here..."
                        ></textarea>
                    </div>

                    {/* Submit Button */}
                    <div className="d-grid">
                        <button type="submit" className="btn btn-dark py-2 rounded-pill fw-bold">
                            Save Changes
                        </button>
                    </div>

                </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;